    /*
    Display Structure:  Array of "OR" rule(s).  Each Rule is an array of "AND" rule(s)
    id_1: [
        or_a: [
            and_c: {},
            and_d: {}
        ],
        or_b: [
            and_e: {},
            and_f: {}
        ]
    ],
    id_2: [
        a: [
            rule: {}
        ]
    ]
    */
   
var display = {}
for(let i=2; i<=10; i++){
    var previous = i-1;

    display[i] = [
        [
            {
                name: 'id: '+i,
                type: 'question',
                ref_id: previous,
                group_id: 1,
                equals: 3
            }
        ]
    ]
}

export default {
    display: {
        // 2: [
        //     [
        //         {
        //             name: 'Q1: [3,4]',
        //             type: 'question',
        //             question_type: 'Radio',
        //             ref_id: 1,
        //             group_id: 1,
        //             contains: [3,4]
        //         }
        //     ]
        // ],
        // 3: [
        //     [
        //         {
        //             name: 'Q2: [1,3]',
        //             type: 'question',
        //             question_type: 'Checkbox',
        //             ref_id: 2,
        //             group_id: 1,
        //             contains: [1,3]
        //         }
        //     ]
        // ],
        // 4: [
        //     [
        //         {
        //             name: 'Q3: 2020-03-01',
        //             type: 'question',
        //             question_type: 'Date',
        //             ref_id: 3,
        //             group_id: 1,
        //             input_id: 1,
        //             contains: '2020-03-01'
        //         },
        //         {
        //             name: 'Q3: 2020-03-05',
        //             type: 'question',
        //             question_type: 'Date',
        //             ref_id: 3,
        //             group_id: 1,
        //             // input_id: 2,
        //             contains: '2020-03-05'
        //         },
        //     ]
        // ]
    },
    valid: {
        1: {
            
            min_value: null,
            max_value: null,
            min_answers: null,
            max_answers: null
        }
    },
    action: {
        1: function(param){
            if(param.question.value[2] == 2){
                console.log('Question 1: - group 2 - input 2 ',param.question.value)
            }
        }
    }
}